const options = {
    rootClass: 'zp-heatmap',
    initType: 1
};

LoaderFactory(options, (function (w, d, $, undefined) {

    const _w = $(w);
    const _d = $(d);


    class Heatmap {

        /**
         * Konstruktor
         * @param {Selector} root
         */
        constructor(root) {
            this.start(root);
        }


        /**
         * foo
         * @param {Selector} root
         */
        start(root) {
            this.initHeatmap(root);
        }

        initHeatmap (root) {

            try{
                let gradiant = $('#' + root.attr('id') + ' .zp-heatmap-gradiant');
                let gradiantSRC = gradiant.attr('src');
                let canvas = $('#' + root.attr('id') + ' canvas')[0];
                let heatmap = createWebGLHeatmap({canvas: canvas, intensityToAlpha:true, gradientTexture: gradiantSRC});
                let windowWidth = window.innerWidth;
                let heatmapPointSize;
                if (windowWidth <= 1024) {
                    heatmapPointSize = 5;
                }
                else {
                    heatmapPointSize = 50;
                }
                console.log(heatmap);

                var paintAtCoord = function(x, y){
                    var count = 0;
                    while(count < 200){
                        var xoff = Math.random()*2-1;
                        var yoff = Math.random()*2-1;
                        var l = xoff*xoff + yoff*yoff;
                        if(l > 1){
                            continue;
                        }
                        var ls = Math.sqrt(l);
                        xoff/=ls; yoff/=ls;
                        xoff*=1-l; yoff*=1-l;
                        count += 1;
                            heatmap.addPoint(x+xoff*heatmapPointSize, y+yoff*heatmapPointSize, 55, 0.009);
                    }
                };

                // event handling
                var onTouchMove = function(evt){
                    evt.preventDefault();
                    var touches = evt.changedTouches;
                    for(var i=0; i<touches.length; i++){
                        var touch = touches[i];
                        paintAtCoord(touch.pageX-$('.zp-heatmap-device-content').offset().left, touch.pageY-$('.zp-heatmap-device-content').offset().top);
                    }
                };
                let touchBox = document.getElementsByClassName('zp-heatmap-device-content')[0];

                touchBox.addEventListener("touchmove", onTouchMove, false);

                touchBox.onmousemove = function(event) {
                    let x = event.offsetX;
                    let y = event.offsetY;

                    paintAtCoord(x, y);

                };

                var raf = window.requestAnimationFrame || window.mozRequestAnimationFrame ||
                    window.webkitRequestAnimationFrame || window.msRequestAnimationFrame;

                var update = function(){
                    //heatmap.addPoint(100, 100, 100, 10/255);
                    heatmap.adjustSize(); // can be commented out for statically sized heatmaps, resize clears the map
                    heatmap.update(); // adds the buffered points
                    heatmap.display(); // adds the buffered points
                    heatmap.multiply(0.99499);
                    heatmap.blur();
                    heatmap.clamp(0.0, 1.0); // depending on usecase you might want to clamp it
                    raf(update);
                };
                raf(update);

            }
            catch(error){
                console.log('Error');
            }

        }

    }

    return Heatmap;

}(window, document, jQuery)));